import { Controller } from "@hotwired/stimulus"

export default class extends Controller {


    bindAddressValue() {
        const address = this.element.dataset.address;
        if (address) {
            this.element.textContent = this.shortenAddress(address);
        }
    }

    shortenAddress(address) {
        return `${address.slice(0, 4)}...${address.slice(-4)}`;
    }


    connect() {
        super.connect();
        this.bindAddressValue();
    }



}